import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Typography, Grid, FormControl, TextField, InputLabel, Box, InputAdornment, IconButton, OutlinedInput, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Visibility, VisibilityOff, AccountCircle } from '@mui/icons-material';
import Swal from 'sweetalert2';
//* Import Component
import Images from 'assets/Images';
import colors from 'app/style/colors';
import { Error } from 'app/components/UI/Error';
import useAuth from 'app/hooks/useAuth';
import { Service } from 'app/config/service';

function Login() {

  const { login } = useAuth();


  // *Login 
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);

  const loginInfo = async (formData) => {
    setLoading(true)
    try {
      let obj = {
        Username: formData.email,
        Password: formData.password
      }
      const { Status, Data, ResponseCode, Message } = await Service.login(obj)
      if (Status === true && ResponseCode === 202) {
        login(Data)
      }
      if (Status === true && ResponseCode === 404) {
        Swal.fire({
          text: Message,
          icon: 'error',
          confirmButtonColor: colors.primary,
        })
      }

    } catch (error) {
      console.log('file: Login.js => line 14 => Login => error', error)
    } finally {
      setLoading(false)
    }
  };


  const [showPassword, setShowPassword] = useState(false);


  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };



  return (
    <Fragment>
      <Grid container xs={12} md={12}
        sx={{
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1038%26quot%3b)' fill='none'%3e%3cpath d='M995.43 91.83L1034.19 91.83L1034.19 105.6L995.43 105.6z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M251.98 294.63 a31.47 31.47 0 1 0 62.94 0 a31.47 31.47 0 1 0 -62.94 0z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M543.46 381.05a50.75 50.75 0 1 0-94.97 35.8z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M763.11 366.66L799.34 366.66L799.34 371.71L763.11 371.71z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M250.2 136.47 a49.44 49.44 0 1 0 98.88 0 a49.44 49.44 0 1 0 -98.88 0z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M385.46 473.34a5.05 5.05 0 1 0 9.64 3.04z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M660.44 73.17a23.7 23.7 0 1 0 22.62-41.66z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M663.08 542.5L693.32 542.5L693.32 558.47L663.08 558.47z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M9.27 549.56L44.28 549.56L44.28 596.28L9.27 596.28z' stroke='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M950.51 379.55L996.59 379.55L996.59 425.63L950.51 425.63z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M804.54 19.73L852.43 19.73L852.43 44.97L804.54 44.97z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M390.54 379.6 a8.31 8.31 0 1 0 16.62 0 a8.31 8.31 0 1 0 -16.62 0z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1203.52 112.87L1253.78 112.87L1253.78 163.13L1203.52 163.13z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1310 397.64L1341.56 397.64L1341.56 450.47L1310 450.47z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M173.97 407.92a14.85 14.85 0 1 0-27.68 10.76z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M44.58 81.31L67.94 81.31L67.94 104.67L44.58 104.67z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M701.27 109.02L727.62 109.02L727.62 135.37L701.27 135.37z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M277.02 456.75L288.79 456.75L288.79 468.52L277.02 468.52z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M863.01 109.4L905.61 109.4L905.61 146.88L863.01 146.88z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M93.73 430.29a48.62 48.62 0 1 0-96.55-11.57z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1223.57 314.72 a35.85 35.85 0 1 0 71.7 0 a35.85 35.85 0 1 0 -71.7 0z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M1261.4 500.37L1296.23 500.37L1296.23 546.9L1261.4 546.9z' stroke='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M185.37 517.29a36.05 36.05 0 1 0 19.27 69.48z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M766.55 275.24 a44.92 44.92 0 1 0 89.84 0 a44.92 44.92 0 1 0 -89.84 0z' stroke='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M293.83 12.4a53.63 53.63 0 1 0 43.7 97.95z' fill='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M845.54 348.24L878.69 348.24L878.69 353.08L845.54 353.08z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M320.15 417.03a26.8 26.8 0 1 0-49.89 19.6z' fill='rgba(255%2c 232%2c 225%2c 1)'%3e%3c/path%3e%3cpath d='M107.96 56.58L113 56.58L113 61.62L107.96 61.62z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M270.81 278.87L296.17 278.87L296.17 304.23L270.81 304.23z' fill='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M329.97 356.94L367.5 356.94L367.5 394.47L329.97 394.47z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3cpath d='M248.8 385.76a52.43 52.43 0 1 0-29.07 100.75z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1416.11 319.77a0.93 0.93 0 1 0-1.1-1.49z' stroke='rgba(250%2c 84%2c 28%2c 1)'%3e%3c/path%3e%3cpath d='M1088.09 409.46 a4.38 4.38 0 1 0 8.76 0 a4.38 4.38 0 1 0 -8.76 0z' stroke='rgba(250%2c 84%2c 28%2c 0.5)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1038'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");`,
          height: '100vh', display: 'flex', alignItems: 'center'
        }}>
        <Grid item xs={12} md={5}
          sx={{
            textAlign: "center",
            borderRadius: 12, boxShadow: 4, height: 450,
            bgcolor: colors.white,
            ml: 10,
            mt: 20,
          }}>
          <Button variant='contained'
            component={Link} to='/'
            sx={{ mt: 2, borderRadius: "10px" }}
          >Go to Home</Button>
          <Typography variant="h4" sx={{ mt: 4 }}>Hi!, Welcome Back.</Typography>
          <img src={Images.login} width="95%" alt="login"
            style={{ borderRadius: '24px' }}
          />
        </Grid>
        <Grid item xs={12} md={5}
          sx={{
            textAlign: "center",
            borderRadius: 12, boxShadow: 4, height: 480,
            bgcolor: colors.white, ml: -4, mt: -20
          }}
        >
          {/* <img src={Images.loginHead} width='30%' style={{ textAlign: 'center', marginTop: 30 }} alt='user Login Icon' /> */}
          <AccountCircle sx={{ textAlign: 'center', color: colors.primary, fontSize: '100px', mt: 5 }} />
          <Typography variant="h5"
            sx={{ color: colors.black, mt: 1 }}
          >
            Login
          </Typography>
          <Typography component={"form"} onSubmit={handleSubmit(loginInfo)}>
            <Box sx={{ mt: 2 }}>
              <FormControl variant="standard" fullWidth sx={{ my: 1, alignItems: 'center' }}>
                <TextField
                  variant="outlined"
                  label="Email"
                  type="email"
                  sx={{ width: '400px' }}
                  error={errors?.email?.message && (true)}
                  {...register("email", {
                    required: 'Please enter your email.',
                  })}
                />
                {errors?.email?.message && (
                  <Error message={errors?.email?.message} />
                )}
              </FormControl>
              <FormControl variant="outlined" fullWidth sx={{ my: 1, width: '400px' }}>
                <InputLabel error={errors?.password?.message && (true)}>Password</InputLabel>
                <OutlinedInput
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  // value={values.password}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        // onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  error={errors?.password?.message && (true)}
                  {...register("password", {
                    required: 'Please create your password.',
                  })}
                // onChange={handleChange('password')}
                />
                {errors?.password?.message && (
                  <Error message={errors?.password?.message} />
                )}
              </FormControl>

            </Box>
            <Typography
              sx={{
                color: colors.black,
                '&:hover': {
                  color: colors.primary,
                  cursor: 'pointer',
                },
              }}
            >
              Forgot Password ?
            </Typography>
            <LoadingButton
              variant="contained"
              type="submit"
              loading={loading}
              sx={{
                borderRadius: "10px",
                p: 1,
                my: 2,
                width: '400px'

              }}
            >
              Login
            </LoadingButton>
          </Typography>
        </Grid>
      </Grid>

    </Fragment >
  );
}

export default Login;